<template>
  <sPopover
    ref="popoverDiscounts"
    v-model="visible"
    placement="bottom-end"
    popper-class="tender-discounts__popper"
    trigger="manual"
    width="488"
    @show="createEditData">
    <div
      slot="reference"
      class="tender-discounts"
      @click.prevent.stop="visible = true">
      <div class="tender-discounts__amount">
        {{ $t('Tenders.BasePrice') }}: {{ value.startAmount }} {{ options.currency }}
      </div>
      <template v-for="(discountItem, discountIndex) in discounts.slice(0, 2)">
        <div :key="discountIndex">
          {{ discountItem.price }} {{ options.currency }} від {{ discountItem.quantity }} {{ options.measure }}
        </div>
      </template>
      <div v-if="discounts.length > 2">
        {{ $t('Purchasing.More') }} {{ discounts.length - 2 }}
      </div>
    </div>
    <div
      class="tender-discounts__modal">
      <div
        class="tender-discounts__modal-close">
        <sButton
          class="ml-auto"
          data-qa="btn-close-dialog"
          icon="cross"
          type="text"
          @click.prevent.stop="visible = false"/>
      </div>
      <sForm
        ref="discounts-form"
        :model="editData"
        :rules="rules">
        <sFormItem
          class="tender-discounts__modal-startAmount"
          prop="startAmount">
          <span
            slot="label"
            class="tender-discounts__modal-startAmount-label">
            {{ $t('Tenders.BasePrice') }}
          </span>
          <sInputNumber
            :disabled="readonly"
            :precision="2"
            :value.sync="editData.startAmount"/>
        </sFormItem>
        <sDivider/>
        <ScrollShadow
          ref="modalContent"
          class="tender-discounts__modal-content">
          <div class="tender-discounts__modal-discount-title">
            {{ $t('Tenders.priceWithDiscountDependingVolume') }}
          </div>
          <transition-group
            name="s-zoom-in-top">
            <sFormItem
              v-for="(discountItem, discountIndex) in editData.discounts"
              :key="discountItem.guid"
              class="tender-discounts__modal-discount"
              :prop="`discounts[${discountIndex}]`">
              <div class="tender-discounts__modal-discount-row">
                <div>
                  <div>{{ $t('Tenders.whenVolumeReached') }}</div>
                  <sInputNumber
                    :disabled="readonly"
                    :precision="2"
                    :use-thousand-separator="true"
                    :value.sync="editData.discounts[discountIndex].quantity">
                    <template slot="append">
                      {{ options.measure }}
                    </template>
                  </sInputNumber>
                </div>
                <div class="ml-6">
                  <div>{{ $t('Catalog.Price') }}</div>
                  <sInputNumber
                    :disabled="readonly"
                    :precision="2"
                    :use-thousand-separator="true"
                    :value.sync="editData.discounts[discountIndex].price">
                    <template slot="append">
                      {{ options.currency }}
                    </template>
                  </sInputNumber>
                </div>
                <sButton
                  v-if="!readonly"
                  class="mt-auto"
                  icon="delete"
                  type="text"
                  @click="deleteDiscount(discountIndex)"/>
              </div>
            </sFormItem>
          </transition-group>
        </ScrollShadow>
      </sForm>
      <sButton
        v-if="!readonly"
        class="tender-discounts__modal-btn-add"
        icon="plus"
        small
        type="text"
        @click="addedDiscount">
        {{ $t('Tenders.AddOption') }}
      </sButton>
      <div
        v-if="!readonly"
        class="tender-discounts__modal-footer">
        <sButton
          small
          @click="applyEditDiscount">
          {{ $t('Common.Apply') }}
        </sButton>
      </div>
    </div>
  </sPopover>
</template>
<script>
import functionRandom from 'mixins/functionRandom'
import ScrollShadow from 'components/common/ScrollShadow.vue'

/**
 * Лесница цен. https://app.clickup.com/t/8678rjthq
 */
export default {
  name: 'TenderDiscounts',
  mixins: [functionRandom],
  data() {
    return {
      visible: false,
      editData: {
        startAmount: null,
        discounts: [],
      },
      rules: {},
    }
  },
  methods: {
    createEditData() {
      const value = this.$_.cloneDeep(this.value)
      this.editData.startAmount = value.startAmount
      this.editData.discounts = (value.discounts || []).map(i => ({
        ...i,
        guid: this.$_createGuid()
      }))
      this.createRules()
    },
    addedDiscount() {
      if (this.readonly) { return }
      this.editData.discounts.push({price: null, quantity: null, guid: this.$_createGuid()})
      this.$nextTick(() => {
        const myDiv = this.$refs.modalContent.$refs.scrollContainer
        this.$_smoothScroll(myDiv)
        this.createRules()
      })
    },
    deleteDiscount(index) {
      if (this.readonly) { return }
      this.editData.discounts.splice(index, 1)
      this.createRules()
    },
    applyEditDiscount() {
      if (this.readonly) { return }

      this.$refs['discounts-form'].validate(async (valid) => {
        if (valid) {
          const value = this.$_.cloneDeep(this.value)
          value.startAmount = this.editData.startAmount
          value.discounts = this.$_.cloneDeep(this.editData.discounts)

          value.discounts.forEach((i) => {
            delete i.guid
          })
          this.$emit('update:value', value)
          this.$refs.popoverDiscounts.showPopper = false
        }
      })
      this.visible = false
    },
    createRules() {
      const that = this

      const getDiscountRules = (result, index) => {
        result[`discounts[${index}]`] = {
          trigger: 'change',
          type: 'object',
          validator(rule, value, callback) {
            value = that.editData.discounts[index]

            if (!value || (!value.price && !value.quantity)) {
              callback(new Error(that.$t('Validate.Required')))
            }
            if (!value.price) {
              callback(new Error(that.$t('Catalog.Price') + ' ' + that.$t('Validate.Required')))
            }
            if (!value.quantity) {
              callback(new Error(that.$t('Tenders.volume') + ' ' + that.$t('Validate.Required')))
            }

            if (that.editData.discounts.find(i => i.price === value.price && i.guid !== value.guid)) {
              callback(new Error(that.$t('Tenders.priceMustBeUnique')))
            }

            if (that.editData.discounts.find(i => i.quantity === value.quantity && i.guid !== value.guid)) {
              callback(new Error(that.$t('Tenders.volumeMustUnique')))
            }

            callback()
          }
        }
        return result
      }

      let result = {
        startAmount: {
          trigger: 'change',
          required: true,
          message: that.$t('Validate.Required')
        },
      }
      this.editData?.discounts.forEach((discountItem, discountIndex) => {
        result = getDiscountRules(result,  discountIndex)
      })
      this.rules = result
      this.$nextTick(() => {
        this.$refs['discounts-form']?.clearValidate()
      })

    }
  },
  computed: {
    discounts() {
      return this.$_.cloneDeep(this.value.discounts || []).sort((a, b) => b.quantity - a.quantity)
    }
  },
  components: {
    ScrollShadow
  },
  props: {
    value: {
      type: Object
    },
    options: {
      type: Object
    },
    readonly: {
      type: Boolean
    },
  },
}
</script>
<style scoped lang="scss">
.tender-discounts {
  padding: 20px 10px;
  cursor: pointer;
  &__amount {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 5px;
  }
  &__modal {
    background-color: var(--v-main__light_green-base);
    border-color: var(--v-main__light_green-base);
    border: thin solid var(--main__green);
    padding: 0 0 17px 0;
    &-close {
      display: flex;
      padding: 5px;
    }
    &-startAmount,
    &-discount,
    &-btn-add {
      margin: 20px 30px 0;
    }
    &-content {
      height: 305px;
      overflow: auto;
    }
    &-startAmount {
      margin-top: 0;
      margin-bottom: 20px;
      &-label {
        padding-bottom: 10px;
        font-weight: 500;
        font-size: 16px;
      }
    }
    &-discount {
      &-row {
        display: grid;
        grid-template-columns: 188px 189px 35px;
      }
      &-title {
        padding: 20px 30px 0px;
        font-size: 16px;
        font-weight: 500;
      }
    }
    &-footer {
      text-align: right;
      padding: 0 23px;
    }
  }
}
</style>
<style lang="scss">
.tender-discounts {
  &__popper {
    margin-top: -30px !important;
  }
}
</style>
